import { ResponsivePie } from '@nivo/pie';
import { useTranslation } from 'react-i18next';

const SvgIcon = ({ centerX, centerY }: { centerX: number; centerY: number }) => (
	<svg
		width='23'
		height='18'
		viewBox='0 0 23 18'
		x={centerX - 11.5} // Adjust to half of the width of the SVG
		y={centerY - 10} // Adjust to half of the height of the SVG
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fill-rule='evenodd'
			clip-rule='evenodd'
			d='M22.5474 0.649161C22.5796 0.496788 22.4384 0.365605 22.2935 0.413251L18.8222 1.55468C18.6776 1.60224 18.6377 1.7924 18.7504 1.89713L19.6526 2.73522C19.2186 2.9764 18.9387 3.33001 18.7417 3.68374C18.5713 3.99002 18.4416 4.34055 18.3336 4.63244C18.3152 4.68209 18.2974 4.73005 18.2802 4.7758C18.0223 5.46146 17.7905 5.92436 17.2274 6.19562C16.9746 6.31739 16.637 6.31018 16.0949 6.05956C15.5902 5.8262 15.0529 5.45111 14.433 5.01835L14.2699 4.90458C13.6149 4.44821 12.8696 3.94073 12.1021 3.64239C11.3162 3.33687 10.4195 3.21664 9.51838 3.65072C8.60087 4.09267 8.12222 4.92845 7.85843 5.78069C7.59754 6.62356 7.51182 7.5934 7.45368 8.46528C7.44267 8.63044 7.43263 8.79159 7.42285 8.94856L7.42283 8.94892C7.3785 9.66063 7.33952 10.2864 7.23927 10.8099C7.10964 11.4868 6.93169 11.672 6.83142 11.7203C6.46804 11.8953 6.20975 11.9347 6.00691 11.931C5.78748 11.9271 5.5889 11.874 5.29729 11.7897L5.26634 11.7807C4.99645 11.7025 4.63716 11.5984 4.22063 11.5878C3.76909 11.5763 3.28767 11.6726 2.74211 11.9353C1.55855 12.5054 0.951759 13.7381 0.640618 14.6542C0.477931 15.1331 0.378247 15.5784 0.319029 15.9028C0.289269 16.0659 0.269347 16.2005 0.256686 16.2962C0.250348 16.3441 0.24581 16.3824 0.242756 16.4098L0.239243 16.4427L0.238244 16.4527L0.237921 16.456L0.237802 16.4573L0.237753 16.4578C0.237732 16.458 0.237711 16.4583 0.979046 16.5202L0.237711 16.4583C0.199122 16.874 0.499746 17.2388 0.909174 17.273C1.31837 17.3072 1.68139 16.9983 1.72032 16.5829L1.72035 16.5826L5.72411 13.4272C5.80119 13.4349 5.88076 13.44 5.96262 13.4415C6.41797 13.4498 6.90459 13.3497 7.45717 13.0835C8.27285 12.6906 8.5627 11.8035 8.70106 11.081C8.82164 10.4514 8.86781 9.70172 8.91178 8.98794V8.98792C8.92091 8.83976 8.92994 8.69315 8.93952 8.54947C8.99808 7.67132 9.0776 6.86774 9.27882 6.21765C9.47713 5.57693 9.75746 5.20022 10.1441 5.01396C10.5472 4.81983 10.9928 4.83534 11.5549 5.05387C12.1356 5.27957 12.7443 5.68445 13.417 6.15309L13.5978 6.2794C14.1884 6.69252 14.8345 7.14439 15.4641 7.43548C16.165 7.75954 17.012 7.96403 17.8531 7.55886C18.9945 7.0091 19.4013 6.01626 19.6708 5.29973C19.6934 5.2397 19.7147 5.18251 19.7351 5.12787L19.7351 5.12764C19.8457 4.83067 19.9284 4.60883 20.0364 4.41469C20.1506 4.20962 20.2588 4.10384 20.3902 4.04055C20.535 3.97077 20.6481 3.86014 20.7222 3.72886L21.451 4.40593C21.5638 4.51065 21.7446 4.45149 21.7767 4.29939L22.5474 0.649161ZM5.43133 13.3841C5.52427 13.4019 5.62201 13.4169 5.72411 13.4272L8.70106 11.081L5.43133 13.3841ZM5.43133 13.3841C5.22603 13.3449 5.04418 13.2923 4.89058 13.2479L4.87345 13.2429C4.57744 13.1573 4.38161 13.1035 4.16559 13.098C3.96845 13.093 3.71924 13.1293 3.36787 13.2986C2.75758 13.5926 2.32639 14.3115 2.04803 15.1311C1.95172 15.4146 1.88153 15.6874 1.8313 15.9199L0.979046 16.5202C1.72038 16.5822 1.72036 16.5824 1.72035 16.5826L1.72038 16.5822L1.72058 16.5803L1.72255 16.562C1.7245 16.5444 1.72778 16.5166 1.73266 16.4797C1.74243 16.4058 1.75856 16.2963 1.78327 16.1609C1.79674 16.0871 1.81264 16.0063 1.8313 15.9199L5.43133 13.3841Z'
			fill='#F6465D'
		/>
	</svg>
);

const WithdrawDonutChart = ({ data }: any) => {
	const { t } = useTranslation();
	const totalBuy = data?.find((item: any) => item.id === 'Deposit')?.value ?? 0;
	const totalSell = data?.find((item: any) => item.id === 'Withdraw')?.value ?? 0;

	const isSellHigher = totalSell > totalBuy;
	return (
		<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
			{/* Container for the donut */}
			<div style={{ height: '90px', width: '90px', position: 'relative' }}>
				<ResponsivePie
					data={data}
					startAngle={-80} // Adjust start and end angle for partial arc
					innerRadius={0.9} // Thin the donut
					enableArcLabels={false}
					enableArcLinkLabels={false}
					isInteractive={false}
					colors={['transparent', '#f6465d']} // Green for active part, light gray for rest
					layers={[
						'arcs',
						// Custom layer for icon inside donut
						({ centerX, centerY }) => (
							<>
								<circle cx={centerX} cy={centerY} r={40} fill='#fdd5db' />
								<circle
									cx={centerX}
									cy={centerY}
									r={20}
									fill='white'
									style={{ filter: 'drop-shadow(0px 0px 5px rgba(0,0,0,0.1))' }} // Light shadow for effect
								/>
								<g
									transform={`rotate(${isSellHigher ? 0 : 90}, ${centerX}, ${centerY})`} // Rotate based on which value is higher
								>
									<SvgIcon centerX={centerX} centerY={centerY} />
								</g>
							</>
						),
					]}
				/>
			</div>

			{/* Container for text */}
			<div style={{ marginLeft: '10px', textAlign: 'left' }}>
				<div className='xss:text-[14px] md:text-[18px] font-bold text-[#333]'>{data[1].value ?? 0}%</div>
				<div className='xss:text-[13px] md:text-[18px] text-[#f6465d]'>{t('withdraw')}</div>
			</div>
		</div>
	);
};

export default WithdrawDonutChart;
